import { Box, CircularProgress, IconButton, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import Base from "../../../Base/views/Base";
import MaterialTable, { MTableToolbar } from "material-table";
import DownloadIcon from "@mui/icons-material/Download";
import history from "../../../../../history";
import { useEffect, useState } from "react";
import { GetAdminTaxDeclarationHelper } from "../../helper/TaxDeclarationHelper";
import { toast } from "react-toastify";
import JSZip from "jszip";
import { ConvertDate, s3Client } from "../../../Base/helper/baseFunctions";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";
import { GetUserWorkLocationHelper } from "../../../Employee/helper/EmployeeHelper";

const TaxAdminPage = () => {
  const [employeeData, setEmployeeData] = useState([]);
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingviewRowId, setViewLoadingRowId] = useState(null);
  const location = useLocation();
  const { tab } = location.state || {};
  const [filters, setFilters] = useState({
        ats_work_location_id: []
  });
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setLoading(true);
    setValue(newValue);
    setTimeout(() => {
      setLoading(false); 
    }, 500);
  };

  const handleView = (event, rowData) => {
    if (value === 0 || value === 3) {
      history.push({
        pathname: "/team-tax-adminview",
        state: { defaultValue: rowData, Mode: "taxAdminView" },
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    GetAdminTaxDeclarationHelper({emp_id: null,
        ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setEmployeeData(res?.data?.data);
      }
    }).finally(()=> setLoading(false))
  }, [filters]);

  const getFilteredData = () => {
    switch (value) {
      case 0:
        return employeeData?.filter((row) => row?.emp_status === "To be verified");
      case 1:
        return employeeData?.filter((row) => row?.emp_status === "Pending");
      case 2:
        return employeeData?.filter((row) => row?.status === "Completed");
      case 3:
        return employeeData?.filter((row) => row?.status === "Action Needed");
      default:
        return employeeData;
    }
  };  

   const handleZipDownload = async (data) => {
    const rowId = data?.[0]?.employee_id; 
    setViewLoadingRowId(rowId);

      const zip = new JSZip();
      for (const row of data?.[0]?.cloud_files) {
        if (row) {
          const bucketParams = {
            Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
            Key: row,
          };
          try {
            const url = await getSignedUrl(
              s3Client,
              new GetObjectCommand(bucketParams),
              { expiresIn: 3 * 60 }
            );
            const response = await fetch(url);
            const blob = await response.blob();
            const file_name = row.split(".").at(-2);
            const fileExtension = row.split(".").at(-1);
            const fileName = `${file_name}.${fileExtension}`;
            zip.file(fileName, blob);
          } catch (err) {
            toast.error(`Error fetching proof for ${data?.[0]?.employee_name}: ${err.message}`);
          }
        }
      }
      zip.generateAsync({ type: "blob" }).then((content) => {
        const zipBlob = new Blob([content], { type: "application/zip" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(zipBlob);
        link.download = `${data?.[0]?.employee_no}_${data?.[0]?.employee_name}_TaxDeclaration`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(() => {
        toast.error("Error generating ZIP file.");
      })
      .finally(() => {
        setViewLoadingRowId(null);
      });
    };

    useEffect(() => {
      if (tab === 2) {
        setValue(tab);
        history.replace({
          pathname: location.pathname,
          state: null,
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[tab])
    const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
    const handleWorkLoacation = () => {
        GetUserWorkLocationHelper().then(res => {
        if(res?.data?.statuscode === 200){
            setWorklocationData({ load: false, values: res?.data?.data || [] })
        } else {
            setWorklocationData({ load: false, values: [] })
        }
        })
    }
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
        }
    }
    useEffect(() => {
        handleWorkLoacation();
    }, []);
    const showWorkLocation = !worklocationData.load && worklocationData.values.length > 1;
  return (
    <Base>
      <Box
        sx={{
          minHeight: "calc(100vh - 65px)",
          maxHeight: "calc(100vh - 65px)",
          overflowY: "auto",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{ mb: 1 }}
        >
          <Tab label="To Be Verified" {...a11yProps(0)} />
          <Tab label="Pending" {...a11yProps(1)} />
          <Tab label="Completed" {...a11yProps(2)} />
          <Tab label="Action Needed" {...a11yProps(3)} />
        </Tabs>
        <Box
          sx={{
            borderRadius: "10px",
            maxHeight: "calc(100vh - 115px)",
            overflowY: "auto",
          }}
        >
          <MaterialTable
            onRowClick={(event, rowData) => {
              handleView(event, rowData);
            }}
            columns={[
              {
                title: "Employee No",
                field: "employee_no",
                headerStyle: { cursor: "pointer" },
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
              },
              {
                title: "Name",
                field: "employee_name",
                headerStyle: { cursor: "pointer" },
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
              },
              {
                title: "Designation",
                field: "designation",
                hidden: value === 0 || value === 2 || value === 3, 
                headerStyle: { cursor: "pointer" },
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
              },
              {
                title: "Work Location",
                field: "work_location_name",
                headerStyle: { cursor: "pointer" },
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
                hidden: !showWorkLocation,
                render: (rowData) => rowData?.work_location_name || "N/A"
              },
              {
                title: "Date of Joining",
                field: "doj",
                hidden: value === 0 || value === 2 || value === 3, 
                headerStyle: { cursor: "pointer" },
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
              },
              {
                title: "Download",
                hidden: value === 1,
                field: "download",
                sorting: false,
                headerStyle: { cursor: "default" },
                render: (rowData) => (
                  <Box>
                    {loadingviewRowId === rowData.employee_id ? ( 
                      <CircularProgress size={25} />
                    ) : (
                      <Tooltip title={rowData?.cloud_files?.length === 0 ? "No Attachment" : "Download"}>
                      <IconButton
                        color="primary"
                        disabled={rowData?.cloud_files?.length === 0}
                        onClick={(event) => {
                          event.stopPropagation(); 
                          handleZipDownload([rowData]);
                        }}
                      >
                        <DownloadIcon />
                      </IconButton>
                    </Tooltip>
                    )}
                  </Box>
                ),
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
              },
              {
                title: "Submitted Date",
                hidden:  value === 1,
                field: "subitted_on",
                headerStyle: { cursor: "pointer" },
                render: (data)=> ConvertDate(data?.subitted_on),
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
              },
              {
                title: "Approved Date",
                hidden: value === 0 || value === 1 || value === 3,
                field: "approved_on",
                headerStyle: { cursor: "pointer" },
                render: (data) => ConvertDate(data?.approved_on),
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
              }
            ]}
            data={getFilteredData()}
            isLoading={loading}
            options={{
              maxBodyHeight: "calc(100vh - 250px)",
              minBodyHeight: "calc(100vh - 250px)",
              rowStyle: {
                fontSize: "13px",
                height: "35px",
              },
              headerStyle: {
                padding: "5px 10px 5px 13px",
                fontWeight: "bold",
              },
              sorting: true,
              search: true,
              searchText: "",
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              searchFieldVariant: "standard",
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              paginationPosition: "bottom",
              exportButton: false,
              exportAllData: false,
              exportFileName: "Employees",
              addRowPosition: "first",
              selection: false,
              actionsColumnIndex: -1,
              grouping: false,
              columnsButton: false,
            }}
            title=""
            components={{
                Toolbar: (props) => (
                  <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                      <Box
                          sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#f3edfd",
                          padding: "0px 0px 0px 20px",
                          flexGrow: 1,
                          minHeight: "48px !important",
                          }}
                      >
                      <Box>
                          <Typography variant='h6'>
                              Employee
                          </Typography>
                      </Box>
                      {showWorkLocation && (
                        <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                            <SelectableMultiSelect
                                multiple
                                label="Work Location"
                                placeholder="Select Location"
                                value={filters?.ats_work_location_id}
                                loading={handleWorkLoacation}
                                fieldLabel="work_location_name"
                                name="ats_work_location_id"
                                size="small"
                                onChangeEvent={handleFilterChange}
                                data={worklocationData}
                                menuHeight={150} // optional
                            />
                        </Box> 
                      )}
                      </Box>
                        <Box
                          sx={{
                              "& .MuiToolbar-root": {
                              padding: "12px 16px !important",
                              margin: "auto !important",
                              minHeight: "48px !important",
                              },
                              "& .MuiFormControl-root": {
                              margin: "0 !important",
                              },
                              "& .MuiInputBase-root": {
                              marginLeft: "-20px !important",
                              }
                          }}
                          >
                              <MTableToolbar {...props} />
                          </Box>
                      </Box>
              ),
            }}
          />
        </Box>
      </Box>
    </Base>
  );
};

export default TaxAdminPage;
